import React from "react";
import { Checkbox, List, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import FilterDropdown from "modules/common/components/filters/filterDropdown";
import { IdNamePair } from "../models";

interface ComponentProps<T extends IdNamePair<string, string>> {
    label: string;
    options: T[];
    selectedOptions?: T[];
    onClickOption: (option: T[]) => void;
    contentCalloutClassName?: string;
}

// TODO: This was taken from Paola's tags branch 22299 - consolidate once it's in main
const CheckboxDropdown = <T extends IdNamePair<string, string>>(props: ComponentProps<T>) => {
    const getUpdatedValues = (value: T) : T[] | undefined => {
        return props.selectedOptions?.find(v => v.id === value.id)
            ? props.selectedOptions?.filter(current => current.id !== value.id)
            : props.selectedOptions?.concat([value]);
    };

    const onClick = (option: T) => {
        const updatedValues = getUpdatedValues(option);
        props.onClickOption(updatedValues ?? []);
    };

    return (
        <FilterDropdown text={props.label}>
            <List disablePadding>
                {props.options.map((option) => (
                    <ListItemButton key={option.id}
                        dense
                        onClick={() => onClick(option)}>
                        <ListItemIcon className="callout-checkbox">
                            <Checkbox
                                edge="start"
                                tabIndex={-1}
                                disableRipple
                                size="small"
                                color="primary"
                                checked={!!props.selectedOptions?.find(o => o.id === option.id)}
                            />
                        </ListItemIcon>
                        <ListItemText primary={option.name} />
                    </ListItemButton>
                ))}
            </List>
        </FilterDropdown>
    );
};

export default CheckboxDropdown;
